<div class="job-order-form-container">
  <form class="job-order-form" [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>Job name</mat-label>
      <input
        matInput
        placeholder="Job name"
        formControlName="code"
        required
        minlength="1"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Customer</mat-label>
      <input matInput placeholder="Customer" formControlName="customer" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Delivery date</mat-label>
      <input
        matInput
        [matDatepicker]="deliveryDate"
        formControlName="deliveryDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="deliveryDate"
      ></mat-datepicker-toggle>
      <mat-datepicker #deliveryDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Job name by customer</mat-label>
      <input
        matInput
        placeholder="Job name by customer"
        formControlName="nameByCustomer"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Job description</mat-label>
      <input
        matInput
        placeholder="Job description"
        formControlName="description"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Job difficulty</mat-label>
      <input matInput placeholder="Difficulty as a number" formControlName="difficulty" />
    </mat-form-field>

    <mat-form-field class="note-field">
      <mat-label>Note</mat-label>
      <textarea matInput placeholder="Note" formControlName="note"></textarea>
    </mat-form-field>
  </form>

  <div class="footer">
    <button
      mat-stroked-button
      color="accent"
      class="btn"
      (click)="onCancelClicked()"
    >
      Cancel
    </button>
    <button
      mat-stroked-button
      color="accent"
      class="btn"
      [disabled]="!formGroup.valid"
      (click)="onOkClicked()"
    >
      Ok
    </button>
  </div>
</div>
